import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Pencil, Trash2 } from "lucide-react";
import { photoSrc } from "./playerHelpers";

function PlayerAvatar({ player }) {
  if (player.photo) {
    return <img src={photoSrc(player.photo)} alt="" className="h-full w-full object-cover" />;
  }
  return (
    <span className="font-heading text-2xl font-bold text-slate-400">
      {player.first_name?.[0]}
      {player.last_name?.[0]}
    </span>
  );
}

export default function PlayerCard({ player, canEdit, onEdit, onDelete }) {
  return (
    <Card
      className="p-5 border-slate-200 hover:shadow-md transition relative"
      data-testid={`player-card-${player.id}`}
    >
      <div className="flex gap-4">
        <div className="h-20 w-20 rounded-2xl overflow-hidden bg-slate-100 flex items-center justify-center shrink-0">
          <PlayerAvatar player={player} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            {player.jersey_number != null && (
              <span className="h-6 min-w-6 px-1.5 rounded-md bg-sky-500 text-white text-xs font-bold flex items-center justify-center">
                {player.jersey_number}
              </span>
            )}
            <h3 className="font-heading font-semibold truncate">
              {player.first_name} {player.last_name}
            </h3>
          </div>
          <div className="text-sm text-slate-500">{player.role || "—"}</div>
          {player.parent_phone && (
            <div className="text-xs text-slate-400 mt-1">📞 {player.parent_phone}</div>
          )}
        </div>
      </div>
      {canEdit && (
        <div className="mt-4 flex justify-end gap-1">
          <Button
            size="icon"
            variant="ghost"
            onClick={() => onEdit(player)}
            data-testid={`edit-player-${player.id}`}
            aria-label="Modifica"
          >
            <Pencil size={15} />
          </Button>
          <Button
            size="icon"
            variant="ghost"
            onClick={() => onDelete(player)}
            data-testid={`delete-player-${player.id}`}
            aria-label="Elimina"
          >
            <Trash2 size={15} className="text-red-500" />
          </Button>
        </div>
      )}
    </Card>
  );
}
